import { GET_PROFILE } from "resources/actionTypes";

export function getProfile(payloadType) {
  const data = {
    payloadType: payloadType,
  };

  return {
    type: GET_PROFILE.GET_PROFILE_REQUESTED,
    payload: data,
  };
}